import { render, staticRenderFns } from "./AdminPermissionManagementView.vue?vue&type=template&id=2d2ff666&scoped=true"
import script from "./AdminPermissionManagementView.vue?vue&type=script&lang=js"
export * from "./AdminPermissionManagementView.vue?vue&type=script&lang=js"
import style0 from "./AdminPermissionManagementView.vue?vue&type=style&index=0&id=2d2ff666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ff666",
  null
  
)

export default component.exports